module.exports = __webpack_public_path__ + "static/media/final_bg.de1b36d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/final_bg.png
// module id = 1115
// module chunks = 21